<template>
  <div>
    <el-row :gutter="10" style="margin-top: 20px;height: 100%; width: 100% ; text-align:middle">
      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12"
      style="text-align: left; float: left; margin-top: 10px"
      v-for="(itemVideo, index) in raceNews"
      :key="index"
      >
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="{
          //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如&quot;16:9&quot;或&quot;4:3&quot;）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: 'video/mp4' || 'video/x-flv' || 'video/webm' || 'video/ogg',
              src: itemVideo.path, //url地址
              // src: &quot;&quot; //url地址
            },
          ],
          poster: itemVideo.coverUrl, //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '视频加载中....', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true, //全屏按钮
          },
        }"
      ></video-player>
      <div
        :title="itemVideo.title"
        style="width: 100%; height: 45px;background: #fff;text-align: left;font-size:15px;float:left;overflow: hidden;text-overflow:ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"
        v-html="itemVideo.title"
      ></div>
      <div
        style="
          width: 100%;
          height: 15%;
          background: #fff;
          text-align: right;
          font-size: 15px;
          float: left;
        "
      >
        <div style="display: inline-block; color: #b1b6bb">
          <span :title=itemVideo.author> {{itemVideo.author.length > 10 ? itemVideo.author.slice(0, 10) + '...' : itemVideo.author}}</span>
          <i class="el-icon-time"></i>
          {{ itemVideo.releaseDate }}
        </div>
      </div>
    </el-col>
    </el-row>
    <!-- <div style="width: 100%; float: left">
      <pagination
        style="text-align: center"
        :total="total"
        :page.sync="queryParams.pageNum"
        @pagination="getRaceNews"
        layout="total,  prev, pager, next, jumper"
      />
    </div> -->
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "videos",
  components: { Pagination },
  props: ["articleVideos"],
  data() {
    return {
      nameEn: "",
      raceNews: [],
      images: [],
      // 总条数
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize:0,
      },
    };
  },
  created() {
    this.nameEn = this.articleVideos;
    this.getRaceNews();
  },
  methods: {
    getRaceNews() {
      //赛事资讯
      var api = this.siteURL + "/actuator/article/selectArticleFile?siteId="+this.siteId+"&nameEn="+this.nameEn+"&pageNum="+this.queryParams.pageNum+"&pageSize="+this.queryParams.pageSize;
      this.axios.get(api, {}).then((response) => {
        this.raceNews = response.data.rows;
        this.total = response.data.total;
      });
    },
  },
};
</script>

<style scoped>
</style>

<style>
.vjs-custom-skin > .video-js .vjs-big-play-button {
  font-size: 1.5em;
}
.vjs-custom-skin > .video-js .vjs-control-bar {
  font-size: 8px;
}
.vjs-custom-skin > .video-js .vjs-play-progress:before {
  top: -0.6em;
}
.vjs-slider-horizontal .vjs-volume-level:before {
  top: -0.6em;
  right: -0.5em;
}
.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-playback-rate
  .vjs-playback-rate-value {
  font-size: 1.2em;
  line-height: 1.9;
}
</style>



// WEBPACK FOOTER //
// src/views/videos.vue